<template>
  <div class="candidates-tab">
    <div class="candidates-tab__table">
      <div class="table-panel">
        <div class="table-panel__buttons">
          <Input
            v-if="quickSearchInput"
            :field="{
              name: quickSearchInput.name,
              type: 'text',
              placeholder: quickSearchInput.placeholder
            }"
            size="big"
            :model="search"
            prefixIcon="Search"
            :noBorder="true"
            class="table-panel__search"
            @set-value="handleChange"
          />
          <FormButtons
            :buttons_menu="[showOnlyNewRespondsSwitch]"
            topPanel
            view-type="detail"
            class="table-panel__switcher"
          ></FormButtons>
        </div>

        <div class="table-panel__buttons">
          <div
            v-for="item in rightButtons"
            :key="item.id"
            class="shadow-level-1"
          >
            <div class="button-wrapper">
              <div
                v-if="
                  item.name == 'HRPAC_CANDIDATE_RESPONDS_FILTERS' &&
                  filtersActive
                "
                class="red-circle"
              ></div>
              <div
                v-if="
                  item.name == 'HRPAC_CANDIDATE_RESPONDS_SORT' && sortActive
                "
                class="red-circle"
              ></div>

              <FormButtons
                :buttons_menu="[[item]]"
                topPanel
                view-type="detail"
              ></FormButtons>
            </div>
          </div>
        </div>
      </div>
      <Table
        v-if="tableData[tableModule]"
        :key="`${
          tableData[tableModule].rows.length
            ? tableData[tableModule].rows[0]['ID'] || 0
            : 0
        }_${
          tableColumn && Object.keys(tableColumn).length
            ? Object.keys(tableColumn).length
            : 0
        }`"
        editableColumns
        singleSelect
        :multipleSelect="getChangeableListView"
        @handleMultiSelection="changeChangeableList"
        :module="tableModule"
        :emptyText="
          tableData[tableModule].rows.length == 0 &&
          (filtersActive || sortActive)
            ? 'Не нашли отклики по выставленным параметрам. Попробуйте изменить параметры поиска.'
            : 'Откликов еще нет.'
        "
        class="table-panel__list shadow-level-1"
      />
      <!--      <FilterDialog-->
      <!--        v-if="is_visible.filters_dialog"-->
      <!--        :is_visible="is_visible.filters_dialog"-->
      <!--        :moduleName="module"-->
      <!--      />-->
      <!--      <SortDialog-->
      <!--        v-if="is_visible.sort_dialog"-->
      <!--        :is_visible="is_visible.sort_dialog"-->
      <!--        :moduleName="module"-->
      <!--      />-->
    </div>
    <RespondCard
      v-if="selectedVacancyRespond || respondLoading"
      :respondId="selectedVacancyRespond.ID"
      @reloadReapods="handleChange('', search || '')"
      class="table-panel__respond shadow-level-1"
    />
  </div>
</template>

<script>
import { store } from '@/store';
import FormButtons from 'Elements/Form/FormButtons';
import Input from 'Elements/Input/Input';
import Table from 'Elements/Table/Table';
// import FilterDialog from 'Elements/Dialog/FilterDialog';
// import SortDialog from 'Elements/Dialog/SortDialog';
import RespondCard from 'Parts/Respond/View/RespondCard';
import { MODULE, ACTION } from '@/utils/constants';

export default {
  created() {
    store.commit(
      'selectionPopup/setBaseParams',
      {
        module: MODULE.CANDIDATE_RESPONDS,
        action: ACTION.LIST_VIEW,
        jsqon_return: 1,
        to_pdf: true,
        query: true
      },
      { root: true }
    );
    store.commit('filters/setParam', {
      name: 'respondsFiltersLoaded',
      val: false
    });
    store.commit('filters/setFilterPopupMetaData', {});
    if (store.state.subpanels.activeSubpanelData?.responds?.custom_search) {
      store.commit(
        'filters/setFiltersConfig',
        store.state.subpanels.activeSubpanelData.responds.custom_search
      );
      store.commit('filters/setParam', {
        name: 'sortActive',
        val: !store.state.subpanels.activeSubpanelData.responds.custom_search
          .sortable.default
      });
    }
  },
  data() {
    return {
      search: '',
      tableModule: 'vacancy_responds',
      module: MODULE.CANDIDATE_RESPONDS
    };
  },
  methods: {
    handleChange(name, value) {
      this.search = value;

      clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        clearTimeout(this.timer);

        store.dispatch('common/fetchQuickSearch', {
          module: this.module,
          intents: this.quickSearchInput.intents[0].request,
          filters: store.state.filters.filterConfig.filters,
          search: this.search
        });
      }, 2000);

      store.commit('filters/setFiltersActive', value ? true : false);
    },
    changeChangeableList(items) {
      store.commit('candidate/setChangeableList', items);
    }
  },
  computed: {
    respondLoading() {
      return store.state.respond.loading;
    },
    showOnlyNewRespondsSwitch() {
      return this.getActiveTabData?.data?.data?.title?.title_buttons.filter(
        item => item.name === 'HRPAC_CANDIDATE_RESPONDS_SHOW_NEW'
      );
    },
    tableData() {
      return store.state.common.tableData || null;
    },
    tableColumn() {
      return store.state.common.tableFields || null;
    },
    quickSearchInput() {
      return (
        this.getActiveTabData?.data?.data?.title?.title_buttons.find(
          elem => elem.name == 'HRPAC_CANDIDATE_RESPONDS_QUICK_SEARCH'
        ) || null
      );
    },
    rightButtons() {
      return !store.state.respond.currentVacancyRespond
        ? !store.state.candidate.changeableList.list.length
          ? this.getActiveTabData?.data?.data?.title?.title_buttons.filter(
              elem =>
                elem.type != 'input' &&
                elem.name != 'HRPAC_CANDIDATES_MASS_ACTION' &&
                elem.type != 'bool'
            )
          : this.getActiveTabData?.data?.data?.title?.title_buttons.filter(
              elem => elem.type != 'input' && elem.type != 'bool'
            )
        : this.getActiveTabData?.data?.data?.title?.title_buttons.filter(
            elem =>
              elem.type != 'input' &&
              elem.name != 'HRPAC_CANDIDATES_MASS_OPTIONS' &&
              elem.name != 'HRPAC_CANDIDATES_MASS_ACTION' &&
              elem.type != 'bool'
          );
    },

    getActiveTabData() {
      return store.state.subpanels.activeSubpanelData['responds'];
    },
    getChangeableListView() {
      return store.state.candidate.changeableList.changeable;
    },
    filtersActive() {
      return store.state.filters.filtersActive;
    },
    sortActive() {
      return store.state.filters.sortActive;
    },
    is_visible() {
      return store.state.common.visible_dialog;
    },
    selectedVacancyRespond() {
      return store.state.respond.currentVacancyRespond || null;
    }
  },
  components: {
    FormButtons,
    Input,
    Table,
    // FilterDialog,
    // SortDialog,
    RespondCard
  }
};
</script>

<style lang="scss" scoped>
.candidates-tab,
.candidates-tab__table,
.table-panel,
.table-panel__buttons,
.table-panel__content {
  display: flex;
}

.candidates-tab__table {
  width: 100%;
  width: -moz-available; /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  width: fill-available;
  flex-direction: column;
}

.candidates-tab {
  container-type: inline-size;
  gap: 16px;

  &__table {
    gap: 20px;
  }
}

.table-panel {
  justify-content: space-between;
  gap: 20px;

  &__search {
    max-width: 220px;
  }

  &__buttons {
    gap: 16px;

    &--mass-actions {
      & > *:first-child:not(:last-of-type) {
        display: none;
      }
    }

    & ::v-deep .el-dropdown {
      height: 40px;
    }
  }

  &__switcher {
    align-content: center;

    & ::v-deep .buttons-panel__switcher {
      gap: 8px;
    }
  }

  &__content {
    gap: 16px;
  }

  &__list {
    height: calc(100vh - 238px);
  }

  &__candidate {
    height: auto;

    & ::v-deep .el-tabs__header {
      width: auto !important;
    }

    & ::v-deep .candidate-card__page {
      height: calc(100vh - 242px);
    }
  }
}

@container (max-width: 1224px) {
  .candidates-tab__table:not(:last-of-type) {
    display: none;
  }

  .table-panel__respond {
    min-width: inherit;
  }
}

@container (min-width: 1225px) {
  .candidates-tab__table:not(:last-of-type) {
    min-width: calc(100% - 888px);
  }

  .table-panel__respond {
    min-width: 872px;
  }
}

.button-wrapper {
  position: relative;
}

.red-circle {
  position: absolute;
  top: 5px;
  right: 9px;
  width: 6px;
  height: 6px;
  z-index: 10;
  border-radius: 100%;
  margin: 0 !important;
  background: $red;
}

.hidden {
  display: none;
}
</style>
